function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { plotPrice } from 'json/factors';
import payments from '../../../../services/payments/payment';
import { DownloadIcon } from '../../../atoms/Icon/Download';
import { PanelContainer, Header, HeaderTitle, IconContainer, Item, Label, PriceLabel, ItemContainer, PaymentButtonContainer, ExitButton, TotalTitle, PlaceHolder } from './style';
var PayPalButton = window.paypal.Buttons.driver('react', {
  React: React,
  ReactDOM: ReactDOM
});

var ShoppingCart = function ShoppingCart(props) {
  var handleRemoveFromCart = function handleRemoveFromCart(id, rate) {
    props.actions.remove(id, rate);
  };

  var handleTogglePanel = function handleTogglePanel() {
    props.togglePanel();
  };

  var show = function show(data, e) {
    var result = Object.keys(data[e].rates).map(function (a) {
      return data[e].rates[a].show;
    });
    var r = result.every(function (a) {
      return !a;
    });
    return r;
  };

  var data = props.shoppingCartState.plots;
  var users_country = props.users_country,
      institution_type = props.institution_type;
  var total = 0;
  var datax = [];

  if (data) {
    datax = Object.keys(data).map(function (id) {
      if (!show(data, id)) return React.createElement("div", null, React.createElement(Label, {
        bold: true,
        width: '90%'
      }, id, ":"), Object.keys(data[id].rates).map(function (rate) {
        var x = data[id].rates;

        if (!x[rate].show) {
          return;
        }

        var price = plotPrice(id, users_country, institution_type, rate);
        total += price;
        return React.createElement(Item, {
          key: rate
        }, React.createElement(ExitButton, {
          onClick: function onClick() {
            return handleRemoveFromCart(id, rate);
          },
          small: true
        }, "X"), React.createElement(Label, {
          width: '50%'
        }, rate), React.createElement(PriceLabel, {
          price: true,
          width: '50%'
        }, price, " USD", ' '));
      }));
    });
  }

  var _createOrder = function createOrder(actions, finalTotal) {
    return total > 0 ? actions.order.create({
      purchase_units: [{
        amount: {
          value: total
        }
      }]
    }) : null;
  };

  var onApprove =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(dataOrder, actions) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", actions.order.capture(dataOrder).then(function (details) {
                return (// Call your server to save the transaction
                  payments.validateOrder(dataOrder).then(function (res) {
                    console.log('Exito'); // eslint-disable-line

                    console.log(res); // eslint-disable-line
                  })
                );
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function onApprove(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return React.createElement(PanelContainer, {
    active: props.active
  }, React.createElement(Header, null, React.createElement(IconContainer, null, React.createElement(DownloadIcon, {
    color: 'black',
    size: '25px'
  })), React.createElement(HeaderTitle, null, 'Download'), React.createElement(ExitButton, {
    onClick: function onClick() {
      return handleTogglePanel();
    }
  }, "X")), React.createElement(ItemContainer, null, datax, total == 0 ? React.createElement(PlaceHolder, null, " No data selected ") : ''), React.createElement(TotalTitle, null, " ", total, " USD "), React.createElement(PaymentButtonContainer, null, React.createElement(PayPalButton, {
    env: 'sandbox',
    createOrder: function createOrder(_, actions) {
      return _createOrder(actions, total);
    },
    onApprove: onApprove,
    onCancel: function onCancel() {
      console.log('Canceled'); // eslint-disable-line
    },
    style: {
      size: 'small',
      color: 'silver',
      shape: 'pill',
      label: 'pay'
    }
  })));
};

ShoppingCart.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
  actions: PropTypes.object,
  togglePanel: PropTypes.function,
  users_country: PropTypes.string,
  institution_type: PropTypes.string,
  shoppingCartState: PropTypes.object
};
export default ShoppingCart;